import React from "react";
import {
  injectStripe,
  PaymentRequestButtonElement,
  Elements
} from "react-stripe-elements";
class PaymentRequestForm extends React.Component {
  constructor(props) {
    super(props);
    // For full documentation of the available paymentRequest options, see:
    // https://stripe.com/docs/stripe.js#the-payment-request-object
    const paymentRequest = props.stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: props.parent.total
    });

    paymentRequest.on("token", ({ complete, token, ...data }) => {
      props.parent.onToken(token);
      //   console.log("Received Stripe token: ", token);
      //   console.log("Received customer information: ", data);
      complete("success");
    });

    paymentRequest.canMakePayment().then(result => {
      this.setState({ canMakePayment: !!result });
    });

    this.state = {
      canMakePayment: false,
      paymentRequest
    };
  }

  render() {
    // console.log(this.props);
    return this.state.canMakePayment ? (
      <PaymentRequestButtonElement
        paymentRequest={this.state.paymentRequest}
        className="PaymentRequestButton"
        style={{
          marginTop: "50px",
          // For more details on how to style the Payment Request Button, see:
          // https://stripe.com/docs/elements/payment-request-button#styling-the-element
          paymentRequestButton: {
            height: "64px"
          }
        }}
      />
    ) : null;
  }
}
export default injectStripe(PaymentRequestForm);



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/PaymentRequestButton.jsx